import React, { useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { TableChart, BarChart } from "@mui/icons-material";
import TablaDatos from "./TablaDatos";
import GraficoDatos from "./GraficoDatos";

// Títulos del eje Y según el tipo de tabla
const getTituloY = (tablaIndex) => {
    const titulosY = {
        0: "Temp. en ºC",
        1: "Acum. en mm",
        2: "Pres. Media en hPa",
        8: "Cant. Ocurr.",
        9: "% Ocurr.",
    };
    return titulosY[tablaIndex] || "Valor";
};

// Tablas que necesitan ajuste automático del rango Y
const tablasConAjusteY = [2, 9];

// Tablas que usan gráfico de líneas en vez de barras
const tablasConGraficoLinea = [0];

export default function PanelTabla({
    titulo,
    subtitulo,
    titulosColumnas,
    datosTabla,
    totalObservaciones,
    titulosColumnas2,
    porMesHora,
    tablaIndex,
}) {
    const [vista, setVista] = useState("tabla");

    if (porMesHora) {
        const titulosFilasViento = [
            "CALMO",
            "VARIABLE",
            "350-360-10",
            "20-30-40",
            "50-60-70",
            "80-90-100",
            "110-120-130",
            "140-150-160",
            "170-180-190",
            "200-210-220",
            "230-240-250",
            "260-270-280",
            "290-300-310",
            "320-330-340",
            "TOTAL",
        ];

        datosTabla[0].forEach((fila, j) => {
            fila[0] = titulosFilasViento[j];
        });
    }

    const handleVistaChange = (event, newVista) => {
        if (newVista !== null) {
            setVista(newVista);
        }
    };

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mb: 2,
                }}
            >
                <ToggleButtonGroup
                    value={vista}
                    exclusive
                    onChange={handleVistaChange}
                    size="small"
                    sx={{
                        bgcolor: "#f5f5f5",
                        borderRadius: 2,
                        "& .MuiToggleButton-root": {
                            border: "none",
                            borderRadius: 2,
                            px: 2,
                            py: 0.75,
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "0.8rem",
                            color: "#757575",
                            "&.Mui-selected": {
                                bgcolor: "#1a8a9e",
                                color: "white",
                                "&:hover": {
                                    bgcolor: "#158394",
                                },
                            },
                            "&:hover": {
                                bgcolor: "#e0e0e0",
                            },
                        },
                    }}
                >
                    <ToggleButton value="tabla">
                        <TableChart sx={{ fontSize: 18, mr: 0.75 }} />
                        Tabla
                    </ToggleButton>
                    <ToggleButton value="barras">
                        <BarChart sx={{ fontSize: 18, mr: 0.75 }} />
                        Gráficas
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>

            {vista === "tabla" && (
                <TablaDatos
                    titulosColumnas={titulosColumnas}
                    titulosColumnas2={titulosColumnas2}
                    datosTabla={datosTabla[0]}
                />
            )}

            {vista === "barras" && (
                <GraficoDatos
                    titulosColumnas={titulosColumnas}
                    titulosColumnas2={titulosColumnas2}
                    datosTabla={datosTabla[0]}
                    tipoGrafico={tablasConGraficoLinea.includes(tablaIndex) ? "line" : "bar"}
                    tituloY={getTituloY(tablaIndex)}
                    ajustarRangoY={tablasConAjusteY.includes(tablaIndex)}
                />
            )}

        </Box>
    );
}
